import dayjs from 'dayjs';
import { Tooltip } from '@mui/material';
import SweetAlert from '../components/Shared/Notification';
import writeXlsxFile from 'write-excel-file';
import readXlsxFile from 'read-excel-file';

// const handleApiError = (error) => {
//   if (error?.response?.status === 403) {
//     SweetAlert('Signature has expired.', 'error');
//     setTimeout(() => {
//       window.location.href = `/#/logout`;
//     }, 1000);
//   } else return error;
// };

const dateFormate = (date = new Date(), formate = 'DD-MM-YYYY') => {
  if (!date) return '';
  return dayjs(date).format(formate);
};
const indianTimeZone = (date = new Date(), hours = 5, minutes = 30) => {
  let newDate = new Date(date);
  newDate.setHours(newDate.getHours() + hours);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  return dayjs(newDate);
};

const USATimeZone = (date = new Date(), hours = 5, minutes = 30) => {
  let newDate = new Date(date);
  newDate.setHours(newDate.getHours() - hours);
  newDate.setMinutes(newDate.getMinutes() - minutes);
  return dayjs(newDate);
};

// const isValidPhoneNumber = (phoneNumber) => {
//   const phoneRegex = /^\d{10}$/;
//   return phoneRegex.test(phoneNumber);
// };
const isValidPhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\d{10,13}$/;
  return phoneRegex.test(phoneNumber);
};

const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

const isValidNumber = (input) => {
  return !isNaN(parseFloat(input)) && isFinite(input);
};

function renderBoldText(text) {
  const parts = text?.split('*');
  return parts.map((part, index) => {
    if (index % 2 === 0) {
      return part;
    } else {
      return <strong key={index}>{part}</strong>;
    }
  });
}

const removeKeysFromObj = (array, keysToRemove) => {
  return array?.map((item) => {
    let newItem = { ...item };
    keysToRemove?.forEach((key) => {
      delete newItem[key];
    });
    return newItem;
  });
};

const renderToolTip = (tooltipText, action, isForm = false, position = 'top') => {
  // MUI placement mapping from Bootstrap positions
  const getPlacement = (pos) => {
    const placementMap = {
      top: 'top',
      bottom: 'bottom',
      left: 'left',
      right: 'right',
      'top-start': 'top-start',
      'top-end': 'top-end',
      'bottom-start': 'bottom-start',
      'bottom-end': 'bottom-end',
      'left-start': 'left-start',
      'left-end': 'left-end',
      'right-start': 'right-start',
      'right-end': 'right-end',
    };
    return placementMap[pos] || 'top';
  };

  const tooltipProps = {
    title: (
      <div
        style={{
          whiteSpace: isForm ? 'pre-line' : 'normal',
          fontSize: '12px',
          padding: '4px 8px',
        }}
      >
        {tooltipText}
      </div>
    ),
    placement: getPlacement(isForm ? 'left' : position),
    arrow: true,
    enterDelay: 250,
    leaveDelay: 400,
    componentsProps: {
      tooltip: {
        sx: {
          bgcolor: isForm ? 'rgba(0, 0, 0, 0.9)' : 'rgba(97, 97, 97, 0.9)',
          color: 'white',
          fontSize: '12px',
          borderRadius: '4px',
          maxWidth: isForm ? '300px' : '200px',
          '& .MuiTooltip-arrow': {
            color: isForm ? 'rgba(0, 0, 0, 0.9)' : 'rgba(97, 97, 97, 0.9)',
          },
        },
      },
    },
  };

  return (
    <Tooltip {...tooltipProps}>
      <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
        {action || 'Text'}
      </span>
    </Tooltip>
  );
};

const generateExcelFile = async (objects = [], schema = [], fileName = 'sample') => {
  await writeXlsxFile(objects, {
    schema,
    fileName: `${fileName}.xlsx`,
  });

  // const schema = [
  // {
  //   column: 'Delivery status',
  //   type: String,
  //   value: row => row["Delivery status"]
  // },
  // {
  //   column: 'Payment status',
  //   type: String,
  //   value: row => row["Payment status"]
  // },
  // ]
  // const DATA_ROW_1 = [
  // {
  //   "Payment status":"succes",
  //   "Delivery status":"Failed",

  // },
  // {
  //   "Payment status":"succes",
  //   "Delivery status":"Failed",

  // }
  // ]
};

const ExcelToJsonConverter = async (file) => {
  try {
    if (file) {
      const rows = await readXlsxFile(file);
      const headers = rows[0];
      const jsonData = [];
      for (let i = 1; i < rows.length; i++) {
        const obj = {};
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = rows[i][j];
        }
        jsonData.push(obj);
      }
      return jsonData;
    } else return [];
  } catch (error) {
    console.error('Error reading the Excel file:', error);
  }
};
const generateFilterKey = (filters) => {
  try {
    const flatFilters = {
      ...filters,
      ...(filters?.dynamicFilters || {}),
    };
    if (flatFilters?.dynamicFilters) {
      const dynamicFilterString = JSON.stringify(flatFilters?.dynamicFilters);
      const queryString = Object.keys(flatFilters)
        .sort()
        .map((key) => `${key}=${flatFilters[key] || ''}`)
        .join('&');
      return `${queryString}&data_filters=${dynamicFilterString}`;
    }
    // delete flatFilters?.dynamicFilters;
    return Object.keys(flatFilters)
      .sort()
      .map((key) => `${key}=${flatFilters[key] || ''}`)
      .join('&');
  } catch (error) {
    console.warn(error);
    return '';
  }
};

const convertToReadableFormat = (inputString) => {
  try {
    const words = inputString.split('_');
    const readableString = words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    return readableString;
  } catch {
    return inputString;
  }
};

const validateLength = (value, minLength, maxLength) => {
  if (minLength && value.length < minLength) {
    return `Minimum length of ${minLength} characters required. You entered ${value.length} characters.`;
  }
  if (maxLength && value.length > maxLength) {
    return `Maximum length of ${maxLength} characters exceeded. You entered ${value.length} characters.`;
  }
  return '';
};

export {
  // handleApiError,
  dateFormate,
  isValidPhoneNumber,
  isValidNumber,
  renderToolTip,
  renderBoldText,
  indianTimeZone,
  USATimeZone,
  removeKeysFromObj,
  generateExcelFile,
  ExcelToJsonConverter,
  isValidEmail,
  generateFilterKey,
  convertToReadableFormat,
  validateLength,
};
